import React, { useState, useContext } from "react";
import { SettingsContext } from "./AccountSettingsButton";
import jsDig from "utils/jsDig.js";
import CustomTooltip from "utils/CustomTooltip";

export default function MetaAdsCustomConversions() {
  const context = useContext(SettingsContext);
  const [customConversions, setCustomConversions] = useState(context.social_section.custom_conversions || []);

  const addCustomConversion = () => {
    setCustomConversions([...customConversions, {id: new Date().valueOf(), name: "", conversion_id: "" }]);
    context.setMetaAdsCustomConversions([...customConversions, {id: new Date().valueOf(), name: "", conversion_id: "" }]);
  };

  const deleteCustomConversion = (index) => {
    const newCustomConversions = customConversions.filter((_, i) => i !== index);
    setCustomConversions(newCustomConversions);
    context.setMetaAdsCustomConversions(newCustomConversions);
  };

  const handleCustomConversionChange = (index, field, value) => {
    const newCustomConversions = customConversions.map((customConversion, i) => {
      if (i === index) {
        return { ...customConversion, [field]: value };
      }
      return customConversion;
    });
    setCustomConversions(newCustomConversions);
    context.setMetaAdsCustomConversions(newCustomConversions);
  };

  return (
    <div className="meta-ads-custom-conversions-inner">
        <div className="custom-conversions-container">
          {customConversions.map((customConversion, index) => (
            <div key={index} className="google-ads-custom-conversion">
              <input type="text" placeholder="Label" value={customConversion.name} onChange={(e) => handleCustomConversionChange(index, "name", e.target.value)} />
              <input type="text" placeholder="ID" value={customConversion.conversion_id} onChange={(e) => handleCustomConversionChange(index, "conversion_id", e.target.value)} />
              <button className="lite-btn btn-secondary" type="button" onClick={() => deleteCustomConversion(index)}>Delete</button>
            </div>
          ))}
          <button className="lite-btn btn-primary" type="button" onClick={addCustomConversion}>Add Custom Conversion</button>
        </div>
    </div>
  );
}
